export const file2Base64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result?.toString() || '');
        reader.onerror = (error) => reject(error);
    });
};

export function dataUrlToFile(dataUrl: string, filename: string): File {
    const arr = dataUrl.split(',');

    const semicolonIndex = arr[0].indexOf(';');
    const mime = arr[0].substring(arr[0].indexOf(':') + 1, semicolonIndex);
    const buff = Buffer.from(arr[1], 'base64');
    return new File([buff], filename, { type: mime });
}
